import { BaseLayout } from '@interhyp/platform-layout';
import { FallbackType, RouteFallbackProps } from '@interhyp/platform-router';
import { StatusCode403, StatusCode404, StatusCode500, Link } from '@platform/elements';
import { useMemo } from 'react';

import styles from './Viewport.fallback.module.scss';
import { useAPMErrorOnce } from '../hooks/useAPMErrorOnce';
import { MissingLogin } from './missingLogin/MissingLogin';

export type RouterFallbackMissingLogin = 'MISSING_LOGIN';

export function ViewportFallback({
  type,
}:
  | RouteFallbackProps
  | {
      type: RouterFallbackMissingLogin;
    }): JSX.Element {
  const errorText = useMemo(() => {
    if (document.referrer) {
      return `ViewportFallback ${type} - linked from ${document.referrer}`;
    }

    return `ViewportFallback ${type} - direct call`;
  }, [type]);

  useAPMErrorOnce(errorText);

  if (type === 'MISSING_LOGIN') {
    return <MissingLogin />;
  }

  if (type === FallbackType.UNAUTHORIZED) {
    return (
      <BaseLayout className={styles.container}>
        <StatusCode403 component={<Link href="/">Zur Startseite</Link>} />
      </BaseLayout>
    );
  }

  if (type === FallbackType.NOT_FOUND) {
    return (
      <BaseLayout className={styles.container}>
        <StatusCode404 component={<Link href="/">Zur Startseite</Link>} />
      </BaseLayout>
    );
  }

  return (
    <BaseLayout className={styles.container}>
      <StatusCode500 component={<Link href="/">Zur Startseite</Link>} />
    </BaseLayout>
  );
}
